import * as React from 'react';
import { Filters as FiltersComponent } from '../../components/Filters';
import { RegionDropdown } from '../RegionDropdown';
import { RoomsCheckbox } from '../RoomsCheckbox';
import { AreaInput } from '../AreaInput';
import { PriceInput } from '../PriceInput';

const filters = [RegionDropdown, RoomsCheckbox, AreaInput, PriceInput];

export function Filters() {
  const filtersComponents = filters.map((Component, index) => <Component key={index} />);

  return <FiltersComponent filters={filtersComponents} />;
}
